//Generated File 
export const ALLOWED_VALUES_PREFIX = `#ALWDVLS#`;
export const ALWAYS_PRINT_ONE_BARCODE = `alwaysPrint1InBarcode`;
export const APPROVAL_CHANGE = `approvalChange`;
export const APPROVAL_MESSAGE = `approval`;
export const ARABIC_KEYBOARD_ = [`ش`, `لا`, `ؤ`, `ي`, `ث`, `ب`, `ل`, `ا`, `ه`, `ت`, `ن`, `م`, `ة`, `ى`, `خ`, `ح`, `ض`, `ق`, `س`, `ف`, `ع`, `ر`, `ص`, `ء`, `غ`, `ئ`, `د`, `ج`, `ط`, `ك`, `ظ`, `ز`, `و`, `ذ`];
export const ARABIC_REPLACE_BY = [`ا`, `ا`, `ا`, `ا`, `ا`, `ه`, `ه`, `ي`, `ي`, `و`, `و`];
export const ARABIC_REPLACE___ = [`إ`, `ا`, `أ`, `آ`, `ء`, `ة`, `ه`, `ى`, `ئ`, `ؤ`, `و`];
export const ATTACHMENT_COMPILED = `.compiled`;
export const ATTACHMENT_FORCEDB = `forcedb`;
export const ATTACHMENT_FORCEREPL = `forcerepl`;
export const ATTACHMENT_FORCEREPLDB = `forcerepldb`;
export const ATTACHMENT_JRXML = `.jrxml`;
export const ATTACHMENT_MESSAGE = `attachment`;
export const AddLineToGridAfterAutoSave = `addLineToGridAfterAutoSave`;
export const AutoSaveAfterInputInFields = `autoSaveAfterInputInFields`;
export const AutoSaveBehavior = `autoSaveBehavior`;
export const BARCODEON = `BARCODEON`;
export const BARCODE_URL_PREFIX = `namabarcode://`;
export const BASE64_PREFIX = `@b64`;
export const BG_IMAGE = `bgImag`;
export const BULK_OPERATION = `@##blkop&&**`;
export const CODE_AND_SATELITE_SEP = `$#`;
export const CONTEXTFIELD_$_THIS = `$this`;
export const CONTEXTFIELD_FORCE_SINGLE_COLUMN = `_FORCE_SINGLE_COLUMN__`;
export const CONTEXTFIELD_SELECTEDLINE = `____SELECTED_LINE___`;
export const CONTEXTFIELD_SELECTEDLINE_INDEX = `__$ELECTED_LINE___INDEX`;
export const CONTEXTFIELD_VISIBLE_FIELDS = `_____VISIBLE_FIELDS___`;
export const CONTEXTFIELD_WHOLELINE = `____ALL_LINE___`;
export const CONTEXTFIELD_WHOLE_ENTITY = `_WHOLE_ENTITY__`;
export const COPY_GRID_LINE = `.$$copyLine$$`;
export const CRT_EXP_CURRENT_EMP_ID = `$currentempid`;
export const CRT_EXP_CURRENT_USER_ID = `$currentuserid`;
export const CapabilityDownloadAttachment = `DownloadAttachment`;
export const CapabilityPreviewAttachment = `PreviewAttachment`;
export const CapabilityUploadAttachment = `UploadAttachment`;
export const CapabilityViewAttachment = `ViewAttachment`;
export const DEFAULT_LAST_PAGE = 99999999;
export const DEFAULT_VALUES_EXPRESSION_PRFX = `#exp#`;
export const DEFAULT_VALUE_CURRENT_VIEW_NAME = `$$$$$current__view_name@@@@`;
export const DEFAULT_VALUE_HALVE_END = `$halveEnd()`;
export const DEFAULT_VALUE_HALVE_START = `$halveStart()`;
export const DEFAULT_VALUE_MINUS_DAYS = `$todayMinusDays(`;
export const DEFAULT_VALUE_MINUS_MONTHS = `$todayMinusMonths(`;
export const DEFAULT_VALUE_MINUS_WEEKS = `$todayMinusWeeks(`;
export const DEFAULT_VALUE_MINUS_YEARS = `$todayMinusYears(`;
export const DEFAULT_VALUE_MONTH_END = `$monthEnd()`;
export const DEFAULT_VALUE_MONTH_START = `$monthStart()`;
export const DEFAULT_VALUE_NEXT_MONTH_END = `$nextMonthEnd()`;
export const DEFAULT_VALUE_NEXT_MONTH_START = `$nextMonthStart()`;
export const DEFAULT_VALUE_NEXT_YEAR_END = `$nextYearEnd()`;
export const DEFAULT_VALUE_NEXT_YEAR_START = `$nextYearStart()`;
export const DEFAULT_VALUE_NOW = `$now()`;
export const DEFAULT_VALUE_PLUS_DAYS = `$todayPlusDays(`;
export const DEFAULT_VALUE_PLUS_MONTHS = `$todayPlusMonths(`;
export const DEFAULT_VALUE_PLUS_PREFIX = `$todayPlus`;
export const DEFAULT_VALUE_PLUS_WEEKS = `$todayPlusWeeks(`;
export const DEFAULT_VALUE_PLUS_YEARS = `$todayPlusYears(`;
export const DEFAULT_VALUE_PREVIOUS_MONTH_END = `$previousMonthEnd()`;
export const DEFAULT_VALUE_PREVIOUS_MONTH_START = `$previousMonthStart()`;
export const DEFAULT_VALUE_PREVIOUS_YEAR_END = `$previousYearEnd()`;
export const DEFAULT_VALUE_PREVIOUS_YEAR_START = `$previousYearStart()`;
export const DEFAULT_VALUE_QUARTER_END = `$quarterEnd()`;
export const DEFAULT_VALUE_QUARTER_START = `$quarterStart()`;
export const DEFAULT_VALUE_THIRD_END = `$thirdEnd()`;
export const DEFAULT_VALUE_THIRD_START = `$thirdStart()`;
export const DEFAULT_VALUE_TODAY = `$today()`;
export const DEFAULT_VALUE_YEAR_END = `$yearEnd()`;
export const DEFAULT_VALUE_YEAR_START = `$yearStart()`;
export const DIRECT_PRINT = `directPrint`;
export const EMAIL_CONTENT = `emailContent`;
export const EMAIL_SUBJECT = `emailSubject`;
export const ENGLISH_KEYBOARD = [`a`, `b`, `c`, `d`, `e`, `f`, `g`, `h`, `i`, `j`, `k`, `l`, `m`, `n`, `o`, `p`, `q`, `r`, `s`, `t`, `u`, `v`, `w`, `x`, `y`, `z`, `]`, `[`, `'`, `;`, `/`, `.`, `,`, `\``];
export const ENTITY_CHANGE = `entityChange`;
export const FAILED = `failed`;
export const FIELD_INFO_ALLOWEDVALUES_SEPERATOR = `#,#`;
export const FIELD_PARTS_SEP = `:`;
export const FISCAL_PERIOD_TYPE_FIELD = `periodType`;
export const FISCAL_PERIOD_TYPE_PURGE = `PurgePeriod`;
export const FindAddDescByEntityTypeQueryName = `FindAddDescByEntityTypeQuery`;
export const FindByLoginIdQueryName = `FindByLoginIdQuery`;
export const FindLayoutByPathQueryName = `FindLayoutByPath`;
export const FocusFieldAfterAutoSave = `focusFieldAfterAutoSave`;
export const GENERIC_REF_ALL = `&all`;
export const GENERIC_REF_ALL_DOCS = `&alldocs`;
export const GENERIC_REF_ALL_MASTERS = `&allmasters`;
export const GENERIC_REF_SIMPLE_AND_ALL = `&sall`;
export const GUI_MODULE_ID = 19;
export const HEAD_OFFICE = `headoffice`;
export const HIJRI_DATE = `hijriDate`;
export const HMS_INVOICE_TYPES = [`HMSSurgeryInvoice`, `HMSAccommodationInvoice`, `HMSAttendantInvoice`, `HMSLabTestInvoice`, `HMSPatientCheckInvoice`, `HMSPhysicalTherapyInvoice`, `HMSRadiologyInvoice`, `HMSServicesInvoice`, `HMSSupervisionInvoice`, `HMSPharmacyInvoice`, `HMSSuppliesInvoice`, `HMSBloodBankInvoice`, `HMSServiceSupplyInvoice`, `HMSPharmacyReturn`, `HMSBloodBankReturn`, `HMSSupplyReturn`];
export const HOPEFULLY_UNIQUE_FIELD_SEP = `_0_0_`;
export const HOPEFULLY_UNIQUE_FIELD_SEP_FOR_SPLIT = `_0_0_`;
export const HR_MIGRATION = `hrMigration`;
export const IGNORED_FIELDS = [`allAdditionalFieldsInXMLDf`, `createTransactionId`, `lastModifyTransactionId`, `lastUpdateDate`];
export const JRXML_FILE_EXTENSION = `.jrxml`;
export const LIST_FUNC_AVG = `avg`;
export const LIST_FUNC_MAX = `max`;
export const LIST_FUNC_MIN = `min`;
export const LIST_FUNC_SEP = `:`;
export const LIST_FUNC_SUM = `sum`;
export const LIST_PARAMS_SEP = `@A=@X`;
export const LOCAL_RETRY_QUEUE = `localRetry`;
export const LOGIN_LEGAL_ENTITY_LOGO = `leImag`;
export const Layout_FilePath = `filePath`;
export const ListAllConfigEntriesQueryName = `ListAllConfigEntriesQuery`;
export const ListAllPickRulesQueryName = `ListAllPickRulesQueryName`;
export const MORE_MENU_SEPERATOR = `:sep:`;
export const MPS_AUTH = `mpsauth`;
export const MPS_AUTH_RETRIEVE = `mpscheckauth`;
export const MPS_CHECK = `checkmps`;
export const MPS_CHECK_LEVEL = `checkmpslevel`;
export const MPS_CHECK_LEVEL_USER_CODE = `checkmpsleveluser`;
export const MPS_PREFIX = `M_oo_pS@~`;
export const NAMA_EVENT_BUS_VERSION = 1;
export const NOTIFICATION_CHANGE = `notificationChange`;
export const NOTIFICATION_MESSAGE = `notificationMessage`;
export const NO_ORDER = `@_NO_ORDER_@`;
export const OLD_NO_ORDER = `%NO_ORDER%^^`;
export const OPEN_LINK_IN_BROWSER_POPUP_WINDOW = `$$%%OpenInBrowserPopupWindow%^^&#`;
export const OPEN_LINK_IN_NEW_WINDOW = `$$%%OpenInNewWindow%^^&#`;
export const OPEN_LINK_IN_POPUP = `$$%%OpenInPopup%^^&#`;
export const PERCENTAGE_SACLE = 2;
export const POS_MODULE_ID = 127;
export const P_HASH_START = `#**#P`;
export const RATE_SCALE = 4;
export const REPLACE_RECORD = `Replace_Current_Record`;
export const REPORT_PARAM_ORIGINAL_PREFIX = `original_`;
export const RE_COMMIT = `reCommit`;
export const RUN_REPORT_SERVLET = `rpt?`;
export const SEPARATOR = `_#_`;
export const SYSTEM_FORMS_CODE_PREFIX = `SYSF-`;
export const TO_EMAIL = `toEmail`;
export const TO_EMP1 = `toEmp1`;
export const UOMConversionScale = 10;
export const URLS_SEPERATOR = `##11##22##3@@@3##44##55##`;
export const URL_TITLE_SEPARATOR = `@!@`;
export const WILD_CARD_REPLICATION_SITE = `*&`;
export const ZIP_FILE_EXTENSION = `.zip`;
export const aDATAGRID_PAGE_SIZE = 25;
export const ignoreNotFoundReferencesAndAddThemToMap = `ignoreNotFoundReferencesAndAddThemToMap`;
export const moveToNextRow = `__MOVE_TO_NEXT_ROW__`;
export const notFoundRefsSet = `notFoundRefsSet`;
